export const cardinalPointsEnum = {
  'north': 'Norte',
  'south': 'Sur',
  'east': 'Este',
  'west': 'Oeste',
  'north-east': 'Nor-Este',
  'north-west': 'Nor-Oeste',
  'south-east': 'Sur-Este',
  'south-west': 'Sur-Oeste',
};